import { Extension } from "@tiptap/core"

/**
 * Mintlify's Accordion maps onto the existing details nodes, which already
 * keep `open` (defaultOpen). This adds the one prop they lack: a description
 * line under the title, stored as `data-description` on the summary and drawn
 * by CSS, so thousands of stored accordions keep their exact HTML.
 */
export const AccordionDescription = Extension.create({
	name: "accordionDescription",

	addGlobalAttributes() {
		return [
			{
				types: ["detailsSummary"],
				attributes: {
					description: {
						default: null,
						parseHTML: (element: HTMLElement) =>
							element.getAttribute("data-description")?.trim() || null,
						renderHTML: (attributes: Record<string, unknown>) =>
							typeof attributes.description === "string" &&
							attributes.description
								? { "data-description": attributes.description }
								: {},
					},
				},
			},
		]
	},
})

export const AccordionExtensions = [AccordionDescription]
